import React from 'react';
import './About.css';

const About = () => {
  return (
    <>
      <section className="page-hero about-hero">
        <div className="container about-hero-grid">
          <div className="hero-content">
            <span className="eyebrow">About us</span>
            <h1>About Oromo Gadaa-UK</h1>
            <p>Preserving our rich cultural heritage while building bridges in the United Kingdom</p>
          </div>
          <div className="hero-image">
            <img src="/Images/2025/walgeeti_1.jpg" alt="Gadaa Community" />
          </div>
        </div>
      </section>

      <div className="about">
        <section className="section about-story">
          <div className="container story-grid">
            <div className="story-block">
              <span className="eyebrow">Our heritage</span>
              <h2>A system of governance older than many nations</h2>
            </div>
            <div className="story-body">
              <p>
                The Gadaa system is a traditional democratic system of governance used by the Oromo people of Ethiopia and Kenya.
                It is a complex system of social organization that has guided Oromo society for centuries, emphasizing equality,
                responsibility, and peaceful conflict resolution.
              </p>
              <p>
                Our community in the UK carries forward these timeless values, adapting them to our modern context while
                maintaining their essential spirit of unity, justice, and collective responsibility.
              </p>
            </div>
          </div>
        </section>

        <section className="section mission-vision">
          <div className="container mv-grid">
            <div className="mv-card mission card">
              <span className="eyebrow">Our mission</span>
              <h2>What drives us</h2>
              <p>
                To preserve, promote, and practice the Gadaa cultural values within the Oromo community in the United Kingdom,
                while fostering integration and mutual understanding with the broader British society.
              </p>
              <ul className="check-list">
                <li>Preserve Oromo language and cultural traditions</li>
                <li>Support community members in their integration journey</li>
                <li>Educate younger generations about their heritage</li>
                <li>Build bridges with other communities in the UK</li>
                <li>Promote the democratic values of the Gadaa system</li>
              </ul>
            </div>
            <div className="mv-card vision">
              <span className="eyebrow">Our vision</span>
              <h2>Where we are going</h2>
              <p>
                A thriving Oromo community in the UK that successfully balances cultural preservation with modern integration,
                contributing positively to British society while maintaining strong connections to our ancestral heritage.
              </p>
            </div>
          </div>
        </section>

        <section className="section values">
          <div className="container">
            <div className="section-head center">
              <span className="eyebrow">Community values</span>
              <h2>The principles we live by</h2>
            </div>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-word">Safuu</span>
                <h3>Ethics</h3>
                <p>Maintaining moral integrity and ethical conduct in all our interactions</p>
              </div>
              <div className="value-item">
                <span className="value-word">Nagaa</span>
                <h3>Peace</h3>
                <p>Promoting peace, harmony, and conflict resolution within our community</p>
              </div>
              <div className="value-item">
                <span className="value-word">Walabummaa</span>
                <h3>Freedom</h3>
                <p>Respecting individual freedom while maintaining collective responsibility</p>
              </div>
              <div className="value-item">
                <span className="value-word">Tokkummaa</span>
                <h3>Unity</h3>
                <p>Building unity and solidarity among all community members</p>
              </div>
            </div>
          </div>
        </section>

        <section className="section leadership">
          <div className="container">
            <div className="section-head">
              <span className="eyebrow">Leadership</span>
              <h2>Our Leadership</h2>
              <p>
                Our community is guided by elected leaders who follow the traditional Gadaa principles of
                democratic governance, transparency, and accountability. Leadership roles rotate regularly
                to ensure broad participation and prevent concentration of power.
              </p>
            </div>
            <div className="leadership-structure">
              <div className="leadership-item card">
                <span className="leader-icon">I</span>
                <h3>Abbaa Gadaa (President)</h3>
                <p>The elected leader who guides the community and represents us in external affairs</p>
              </div>
              <div className="leadership-item card">
                <span className="leader-icon">II</span>
                <h3>Council of Elders</h3>
                <p>Experienced community members who provide wisdom and guidance on important matters</p>
              </div>
              <div className="leadership-item card">
                <span className="leader-icon">III</span>
                <h3>Youth Representatives</h3>
                <p>Young community members who ensure the voice of the next generation is heard</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
